<template>
  <div class="home-page-view">
    <div class="top-box">
      <div class="user-info">
        <i class="el-icon-mobile-phone">
            <span class="icon-content"><span style="font-size:0.8vw; margin-left: 10px; cursor: pointer">移动端</span></span>
        </i>
        <i @click="downloadFile" class="el-icon-video-camera-solid" style="font-size:1vw;cursor: pointer"></i>
        <span @click="downloadFile" style="margin-left: 10px; margin-right: 16px;cursor: pointer">
          视频插件</span>
        <i class="el-icon-user" style="font-size:1vw"></i>
        <span style="margin-left: 10px; margin-right: 16px">
          {{ user.realName }} |
        <span @click="loginOut" style="margin-left: 6px; cursor: pointer" >退出</span ></span>
      </div>
    </div>
    <div class="container">
     <div class="left-box">
      <div class="big-title">
        <span class="title-text">岳口工业园区重大安全风险防控平台</span>
      </div>
      <div class="content-title">
        <span class="body-title-text" @click="goToPage(iocMenu?.sysUrl)">智慧驾驶舱</span>
      </div>
      <div class="main-item">
        <div class="inner-item rotate"
          v-for="item in mainMenuList"
          :key="item.key"
        >
          <div class="list-item-box"
              :class="item.class"
              @click="goToPage(item?.sysUrl)"
          >
            <span class="content-name">{{ item.sysName }}</span>
          </div>
        </div>
      </div>
     </div>
     <div class="right-box">
        <div class="content-item"
          v-for="item in otherMenuList"
          :key="item.key"
          @click="goToPage(item?.sysUrl)"
        >
          <span class="content-text">{{ item.sysName }}</span>
        </div>
     </div>
    </div>
  </div>
</template>

<script>
import { Get } from "../utils/khHttp";
import { MessageBox } from "element-ui";
export default {
  name: "HomePage",
  data() {
    return {
      user: {},
      allMenuList:[],
      imgList:[
        'closed-park',
        'wisdom-emergency',
        'double-prevention',
        'special-work',
        'hazard-web',
        'safe-production',
      ],
      isActive:false,
    };
  },
  computed:{
    mainMenuList(){
      return this.imgList.slice(0, 6).map(value => {
        return {
          ...this.allMenuList.find(item => item.sysUrl.includes(value)),
          img: value,
          class: value,
        }
      })
    },
    otherMenuList() {
      return this.allMenuList.slice(6).filter(item => {
        const includedUrls = ['wisdom-envprotect', 'public-pipe-gallery','public-engineering', 'identify-resolve-web', 'safety-training', 'data-service-design-web', 'http://111.46.231.65:5019/html/index.html', 'support-platform'];
        return includedUrls.some(url => item.sysUrl.includes(url));
      });
    },
    iocMenu() {
      return this.allMenuList.find(item => item.sysUrl.includes('wisdom-ioc'))
    }
  },
  mounted() {
    this.getSystemList();
  },
  methods: {
    downloadFile() {
      const fileUrl = 'http://111.46.231.65:82/resource/VideoWebPlugin.exe';
      this.triggerFileDownload(fileUrl);
    },
    triggerFileDownload(url) {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'VideoWebPlugin.exe');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    /**
     * @description 获取图片路径
     * @author hu zhen
     * @date 2024/04/01
    **/
    getImagePath(img) {
      return require('@/assets/images/home-view/' + img + '.png');
    },
    /**
     * 退出登录
     * @method
     * @Description: 退出登录
     * @author hu zhen
     * @date 2024/04/01
     */
    loginOut() {
      // 此处请求的Api直接会绕过CAS的校验
      MessageBox.confirm("确认退出当前用户吗?", "提示", {})
        .then(() => {
          Get("/apc/logout", {}).then((res) => {
            if (res) {
              window.location.href = res.logoutUrl;
            } else {
              this.$notify.error({
                title: "错误",
                message: "退出失败,请联系管理员",
              });
            }
          });
        })
        .catch((e) => {
          console.log("$confirm catch" + e);
        });
    },
    /**
     * 跳转指定页面
     * @method
     * @Description: 跳转指定页面
     * @param{String} sysUrl - 系统地址
     * @author hu zhen
     * @date 2024/04/01
     */
     goToPage(sysUrl) {
      sysUrl && window.open(sysUrl)
    },
     /**
     * 获取系统列表数据
     * @method
     * @Description: 获取系统列表数据
     * @author hu zhen
     * @date 2024/04/01
     */
     async getSystemList() {
      const res = await Get("/api/user/listSys", {sysName: "", agentAccount: "", status: ""})
      if (res.errCode === 0) {
        this.user = res.user
        this.allMenuList = res.list.filter(item => item.status === "0")
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$distans: 100px;
$right-distant: 50px;
$total-elements: 6;
@font-face {
  font-family: Alimama_ShuHeiTi_Bold;
  src: url("@/assets/fonts/Alimama_ShuHeiTi_Bold.ttf");
}

.home-page-view {
  height: 100%;
  width: 100%;
  background: url("@/assets/images/home-view/bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  overflow: hidden;
  flex-flow: column;
  .top-box {
    height: 50px;
    width: 100%;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: flex-end;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: flex-start;
    padding-top: 10px;
    box-sizing: border-box;
    line-height: 22px;

    .user-info{
      color: #fff;
      font-size: 0.8vw;
      padding-right: 31px;
      display: flex;
      align-items: center;
      margin-top: 10px;

      .el-icon-mobile-phone {
                font-size: 1vw;
                cursor: pointer;
                position: relative;
                z-index: 99999;
                margin-right: 25px;

                .icon-content {

                  &::before, &::after {
                    content: '';
                    position: absolute;
                    visibility: hidden;
                    z-index: 99999;
                  }

                  &::before {
                    top: 30px;
                    left: 0;
                    border: 5px solid transparent;
                    border-bottom-color: #fff;
                  }

                  &::after {
                    top: 40px;
                    left: -45px;
                    width: 120px;
                    height: 120px;
                    background: url("http://111.46.231.65:82/resource/qr-code.jpg") center/contain no-repeat;
                  }
                }

                &:hover {
                  .icon-content::before, .icon-content::after {
                    visibility: visible;
                  }
                }

                //

          }

    }
  }
  .container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;
    height: calc(100% - 50px);
    color: #fff;
    .left-box{
      height: 100%;
      width: 80%;
      position: relative;
      .big-title{
        width: 800px;
        text-align: center;
        height: 116px;
        line-height: 116px;
        position: absolute;
        left: 50%;
        top: 60px;
        transform: translate(-50%,-50%);
        background: url('@assets/images/home-view/title-bg.png') no-repeat;
        background-size: 100% 100%;
        .title-text{
          font-family: Alimama_ShuHeiTi_Bold;
          font-size: 34px;
        }
      }
      .content-title{
        cursor: pointer;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        .body-title-text{
          font-size: 40px;
          font-family: Alimama_ShuHeiTi_Bold;
        }
      }

      .main-item {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;

          .inner-item{
            position: absolute;
            animation: float 3s infinite ease-in-out;
            &:first-child{
              top: -254px;
              left: 200px;
              animation-delay: 0s;
            }

            &:nth-child(2){
              top: -65px;
              left: 397px;
              animation-delay: 0.4s;
            }

            &:nth-child(3){
              top: 121px;
              left: 154px;
              animation-delay: 0.8s;
            }

            &:nth-child(4){
              top: 69px;
              left: -294px;
              animation-delay: 1.2s;
            }

            &:nth-child(5){
              top: -91px;
              left: -542px;
              animation-delay: 1.6s;
            }

            &:nth-child(6){
              top: -286px;
              left: -379px;
              animation-delay: 2s;
            }

            .list-item-box{
              position: relative;
              width: 175px;
              height: 180px;
              background-size: 100% 100%;
              cursor: pointer;

              .content-name{
                position: absolute;
                top: 70%;
                right: 50%;
                transform: translate(50%,15%);
                font-family: Alimama_ShuHeiTi_Bold;
                font-size: 19px;
                width: 100%;
              }
            }
            .closed-park{
              background-image: url('@assets/images/home-view/closed-park.png');
              &:hover,&.active{
                background-image: url('@assets/images/home-view/closed-park-active.png');
              }
            }
            .wisdom-emergency{
              background-image: url('@assets/images/home-view/wisdom-emergency.png');
              &:hover,&.active{
                background-image: url('@assets/images/home-view/wisdom-emergency-active.png');
              }
            }
            .double-prevention{
              background-image: url('@assets/images/home-view/double-prevention.png');
              &:hover,&.active{
                background-image: url('@assets/images/home-view/double-prevention-active.png');
              }
            }
            .special-work{
              background-image: url('@assets/images/home-view/special-work.png');
              &:hover,&.active{
                background-image: url('@assets/images/home-view/special-work-active.png');
              }
            }
            .hazard-web{
              background-image: url('@assets/images/home-view/hazard-web.png');
              &:hover,&.active{
                background-image: url('@assets/images/home-view/hazard-web-active.png');
              }
            }
            .safe-production{
              background-image: url('@assets/images/home-view/safe-production.png');
              &:hover,&.active{
                background-image: url('@assets/images/home-view/safe-production-active.png');
              }
            }
          }

          @keyframes float {
            0% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-10px);
            }
            100% {
              transform: translateY(0);
            }
          }
        }
    }
    .right-box{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      height: 100%;
      width: 20%;
      .content-item{
        // position: absolute;
        display: flex;
        width: 320px;
        height: 88px;
        align-items: center;
        font-family: Alimama_ShuHeiTi_Bold;
        font-size: 18px;
        background: url("@/assets/images/home-view/common-system.png") no-repeat;
        cursor: pointer;
        margin-bottom: 10px;

        &:first-child{
          margin-right: -60px;
        }

        &:nth-child(8){
         margin-right: -60px;
         margin-bottom: 0;
        }

        &:hover,&.active{
          background: url("@/assets/images/home-view/common-system-active.png") no-repeat;
        }
        .content-text{
          padding-left: 34px;
          width: 250px;
          text-align: center;
        }
      }
    }
  }
}
</style>
